import { useMemo } from 'react';
import { v4 as uuid } from 'uuid';

interface SkeletonEntity {
  id: string;
}

export const useGetSkeletonArray = (size = 5): SkeletonEntity[] =>
  useMemo(() => new Array(size).fill(null).map(() => ({ id: uuid() })), [size]);
